import React, { ReactElement } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { selectOnboardingModalData } from '../../../../../store/slices/modals.slice';
import BackButton from '../../../../Atoms/BackButton/BackButton';
import Button from '../../../../Atoms/Button/Button';
import RadioWide from '../../../../Atoms/RadioWide/RadioWide';
import { OnboardingStepInterface, Steps } from '../../OnboardingModal';
import styles from './PersonaTypeStep.module.scss';

const PersonaTypeStep = ({ goToStep, control, getValues }: OnboardingStepInterface): ReactElement => {
  const {
    Step3: { options, title }
  } = useSelector(selectOnboardingModalData, shallowEqual);

  return (
    <>
      <p className={styles.title}>{title}</p>
      {options.map(({ id, label, value }) => (
        <div key={id}>
          <RadioWide required name='personaType' control={control} id={id} value={value} label={label} />
        </div>
      ))}
      <div className={styles.buttons}>
        <BackButton onClick={goToStep(Steps.TIMEZONE)} />
        <Button
          disabled={!getValues().personaType}
          className={styles.nextButton}
          onClick={goToStep(Steps.PERSONA_LEVEL)}
          value={'Next'}
        />
      </div>
    </>
  );
};

export default PersonaTypeStep;
